import {User} from "types/User";
import {PartialUserData} from "types/PartialUserData";
import {defaultUser} from "constants/defaultUser";

export default function createPartialUserDataFromUser(user: User): PartialUserData {
  const {"@id": id = "fillerId", email, name, firstName = "", lastName = "", avatarColor, initials, avatarPhotoUrl} = user;
  return {...defaultUser, "@id": id, email, name, firstName, lastName, avatarColor, initials, avatarPhotoUrl: avatarPhotoUrl ?? null}
}
